// extracted by mini-css-extract-plugin
export default {"pageContainer":"style_pageContainer__ErCI3","details":"style_details__FChSF","contacts":"style_contacts__ZnoL2"};